function NoRowsOverlay({ text }) {
    return <span>{text}</span>;
}

export default NoRowsOverlay;
